import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asbmchotelmanagementandcatering',
  templateUrl: './asbmchotelmanagementandcatering.component.html',
  styleUrls: ['./asbmchotelmanagementandcatering.component.scss']
})
export class AsbmchotelmanagementandcateringComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
